/**
 * Cart Drawer Fix - Ensures cart drawer opens properly
 * This script adds a global helper for opening the cart drawer
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Create a global helper for opening the cart drawer
    window.openCartDrawer = function(triggerElement) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return false;
      
      // Try built-in method first
      if (typeof cartDrawer.open === 'function') {
        try {
          if (triggerElement && typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(triggerElement);
          }
          cartDrawer.open(triggerElement || null);
          return true;
        } catch (e) {
          console.error('Error opening cart drawer:', e);
        }
      }
      
      // Fallback method: manually apply classes
      try {
        // Apply the animation classes
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        
        // Set animation order for cart items
        const cartItems = cartDrawer.querySelectorAll('.cart-item');
        cartItems.forEach((item, index) => {
          item.style.setProperty('--animation-order', index);
        });
        
        return true;
      } catch (e) {
        console.error('Error applying cart drawer classes:', e);
        return false;
      }
    };
    
    // Override the cart-drawer's open method if it doesn't exist
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open !== 'function') {
      cartDrawer.open = function(triggerElement) {
        if (triggerElement && typeof this.setActiveElement === 'function') {
          this.setActiveElement(triggerElement);
        }
        
        setTimeout(() => {
          this.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        });
        
        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            
            // If trapFocus is available, use it
            if (typeof trapFocus === 'function') {
              trapFocus(containerToTrapFocusOn, focusElement);
            }
          },
          { once: true }
        );
      };
    }
    
    // Fix compatibility with add-to-cart buttons
    document.addEventListener('cart:refresh', function(e) {
      setTimeout(() => {
        window.openCartDrawer(e.detail?.trigger || null);
      }, 100);
    });
  });
})(); 